import {
  CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED,
  CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_LIST_OPEN,
  ID_VARIANT_SELECT,
  SELECTOR_DROPDOWN_OPTION_ITEM,
  SELECTOR_DROPDOWN_OPTION_LIST,
  SELECTOR_DROPDOWN_OPTION_TEXT,
  SELECTOR_DROPDOWN_SELECTED_OPTION,
} from '../constants';

/**
 * @type {import('../index').handleDropdownEvents}
 */
export function handleDropdownEvents(context, dropdownElement) {
  if (!dropdownElement) return;

  const selectedOption = dropdownElement?.querySelector(SELECTOR_DROPDOWN_SELECTED_OPTION);
  const optionList = dropdownElement?.querySelector(SELECTOR_DROPDOWN_OPTION_LIST);
  const options = dropdownElement?.querySelectorAll(SELECTOR_DROPDOWN_OPTION_ITEM);

  function setDefaultOption(context) {
    const currentSelected = dropdownElement?.querySelector(
      `.${CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED}`
    );

    if (!currentSelected && options.length > 0) {
      const firstOption = options[0];

      const [getVariant] = context.useContextState('bis-variant', {});
      const selectedVariant = getVariant();
      const selectedVariantTitle = selectedVariant.title;
      const selectedOption = Array.from(options).find(
        (option) => option.textContent.trim() === selectedVariantTitle
      );

      const selectedText = dropdownElement?.querySelector(SELECTOR_DROPDOWN_OPTION_TEXT);
      if (selectedOption) {
        selectedOption.classList.add(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED);
        selectedOption.setAttribute('aria-selected', 'true');
        selectedText.textContent = selectedOption.textContent;
      } else {
        firstOption.classList.add(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED);
        firstOption.setAttribute('aria-selected', 'true');
        selectedText.textContent = firstOption.textContent;
      }
    }
  }

  function toggleDropdown() {
    const isExpanded = dropdownElement.getAttribute('aria-expanded') === 'true';
    dropdownElement.setAttribute('aria-expanded', !isExpanded);
    optionList.classList.toggle(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_LIST_OPEN, !isExpanded);

    if (!isExpanded) {
      options.forEach((option, index) => {
        if (option.classList.contains(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED)) {
          option.focus();
          return;
        }
        if (index === 0) option.focus();
      });
    }
  }

  function selectOption(option) {
    const selectedText = dropdownElement?.querySelector(SELECTOR_DROPDOWN_OPTION_TEXT);
    const previousSelected = dropdownElement?.querySelector(
      `.${CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED}`
    );

    if (previousSelected) {
      previousSelected.classList.remove(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED);
      previousSelected.setAttribute('aria-selected', 'false');
    }

    option.classList.add(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED);
    option.setAttribute('aria-selected', 'true');
    selectedText.textContent = option.textContent;
    dropdownElement.setAttribute('aria-expanded', 'false');
    optionList.classList.remove(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_LIST_OPEN);
    selectedOption.focus();
  }

  function handleClickOutside(event) {
    if (!dropdownElement.contains(event.target)) {
      dropdownElement.setAttribute('aria-expanded', 'false');
      optionList?.classList.remove(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_LIST_OPEN);
    }
  }

  if (selectedOption) {
    selectedOption.addEventListener('click', toggleDropdown);
  }

  options.forEach((option) => {
    option.addEventListener('click', () => {
      selectOption(option);
    });
  });

  document.addEventListener('click', handleClickOutside);

  setDefaultOption(context);
}

/**
 * @type {import('../index').resetDefaultOptionDropdown}
 */
export function resetDefaultOptionDropdown(selectedVariant) {
  const variantSelect = document.getElementById(ID_VARIANT_SELECT);
  const options = variantSelect?.querySelectorAll(SELECTOR_DROPDOWN_OPTION_ITEM);
  const selectedText = variantSelect?.querySelector(SELECTOR_DROPDOWN_OPTION_TEXT);
  const currentSelected = variantSelect?.querySelector(
    `.${CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED}`
  );

  if (options && options.length > 0 && currentSelected) {
    const selectedVariantTitle = selectedVariant.title;
    const selectedOption = Array.from(options).find(
      (option) => option.textContent.trim() === selectedVariantTitle
    );

    if (selectedOption) {
      currentSelected.classList.remove(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED);
      selectedOption.classList.add(CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED);
      selectedOption.setAttribute('aria-selected', 'true');
      selectedText.textContent = selectedOption.textContent;
    }
  }
}
